export const Radio = {
  baseStyle: {},
  variants: {
    primary: {
      _focusVisible: {
        shadow: 'outline',
      },
      _focus: {
        shadow: 'none',
      },
    },
    accent: {
      control: {
        _checked: {
          bg: 'brand.accent',
          color: 'brand.white',
          borderColor: 'brand.accent',
          _hover: {
            bg: 'brand.accent',
            color: 'brand.white',
            borderColor: 'brand.accent',
          },
        },
      },
    },
  },
  // The default variant values
  defaultProps: {
    variant: 'primary',
  },
}
